import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import { PolicyImpactData } from '../types';
import { TemplateState } from '../../../types/common/types';

export class MaintenanceWindowsDeleteDialogView extends BaseWebComponentView {
  getDomElements() {
    this.dom = {
      $warningText: this.shadow.querySelector('#warning-text'),
      $impactInfoWrapper: this.shadow.querySelector('.impact-info-wrapper'),
      $impactSummaryText: this.shadow.querySelector('#impact-summary-text'),
      $impactDetailsText: this.shadow.querySelector('#impact-details-text'),
    };

    this.setTranslatedStrings();
    this.setLoadingState();
  }

  setTranslatedStrings() {
    this.dom.$warningText.innerText = this.dependencies.translateFn(
      'If you delete this maintenance window, the Patch Management module will be automatically disabled until you assign a new maintenance window to the impacted policies.'
    );
  }

  public setLoadingState(): void {
    this.resetTemplateState(this.dom.$impactInfoWrapper);
    this.setTemplateState(this.dom.$impactInfoWrapper, TemplateState.LOADING);
  }

  public removeLoadingState(): void {
    this.resetTemplateState(this.dom.$impactInfoWrapper);
  }

  buildSuccessView(data: PolicyImpactData) {
    this.dom.$impactSummaryText.innerHTML = this.dependencies.translateFn(
      'This action will impact {numPolicies} policies.',
      {
        numPolicies: `<strong>${data.policyCount}</strong>`,
      }
    );

    const impactDetails = this.getImpactDetails(data);
    this.dom.$impactDetailsText.innerHTML = impactDetails.innerHTML;
    this.removeLoadingState();
  }

  private getImpactDetails(data: PolicyImpactData): HTMLElement {
    const impactDetails = document.createElement('div');

    if (data.policyCount === 0) {
      // If no lists to display, return empty div
      return impactDetails;
    }

    data.policyNames.slice(0, 5).forEach(policy => {
      const item = document.createElement('div');
      item.innerHTML = policy.name;
      impactDetails.appendChild(document.createElement('br'));
      impactDetails.appendChild(item);
    });

    if (data.policyCount > 5) {
      const item = document.createElement('div');
      item.innerHTML = this.dependencies.translateFn('+ {numExtraPolicies} more policies', {
        numExtraPolicies: data.policyCount - 5,
      });
      impactDetails.appendChild(document.createElement('br'));
      impactDetails.appendChild(item);
    }

    return impactDetails;
  }
}
